import 'phaser';
import { language } from './language';
import { CST } from '../CST';
import Board from './board';

var clickSound;

export default class EndScreen extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.ENDSCREEN);
	}

	init() {}

	preload() {
		this.load.image('bg-end-game', 'assets/english/bg-end-game.png');
		this.load.image('home_btn', 'assets/english/home.png');
		this.load.image('replay_btn', 'assets/english/replay.png');
		this.load.image('affirmation-card', 'assets/english/end-cards/affirmation-card.png');
		this.load.image('prayer-card', 'assets/english/end-cards/prayer-card.png');
		this.load.image('trophy-card', 'assets/english/end-cards/trophy-card.png');
		this.load.image('zoom-affirmation-card', 'assets/english/end-cards/zoom-affirmation-card.png');
		this.load.image('zoom-prayer-card', 'assets/english/end-cards/zoom-prayer-card.png');
		this.load.image('zoom-trophy-card', 'assets/english/end-cards/zoom-trophy-card.png');
		this.load.image('affirmation-back', 'assets/english/end-cards/affirmation-back.png');
		this.load.image('prayer-back', 'assets/english/end-cards/prayer-back.png');
		this.load.image('trophy-back', 'assets/english/end-cards/trophy-back.png');
		this.load.spritesheet({ key: 'affirmation-card-sprite', url: 'assets/english/end-cards/affirmation-card-sprite.png', frameConfig: { frameWidth: 643.8, frameHeight: 814 } });
		this.load.spritesheet({ key: 'affirmation-back-sprite', url: 'assets/english/end-cards/affirmation-back-sprite.png', frameConfig: { frameWidth: 643.8, frameHeight: 814 } });
		this.load.spritesheet({ key: 'prayer-card-sprite', url: 'assets/english/end-cards/prayer-card-sprite.png', frameConfig: { frameWidth: 643.8, frameHeight: 814 } });
		this.load.spritesheet({ key: 'prayer-back-sprite', url: 'assets/english/end-cards/prayer-back-sprite.png', frameConfig: { frameWidth: 643.8, frameHeight: 814 } });
		this.load.spritesheet({ key: 'trophy-card-sprite', url: 'assets/english/end-cards/trophy-card-sprite.png', frameConfig: { frameWidth: 643.8, frameHeight: 814 } });
		this.load.spritesheet({ key: 'trophy-back-sprite', url: 'assets/english/end-cards/trophy-back-sprite.png', frameConfig: { frameWidth: 643.8, frameHeight: 814 } });
		this.load.spritesheet({ key: 'firework-blue', url: 'assets/firework-blue.png', frameConfig: { frameWidth: 384.03, frameHeight: 385 } });
		this.load.spritesheet({ key: 'firework-red', url: 'assets/firework-red.png', frameConfig: { frameWidth: 384.03, frameHeight: 385 } });
		this.load.spritesheet({ key: 'firework-yellow', url: 'assets/firework-yellow.png', frameConfig: { frameWidth: 384.03, frameHeight: 385 } });
	}

	create(data) {
		let self = this;
		this.chatChannel = new BroadcastChannel('chat_channel');

		clickSound = this.sound.add('clickSound');

		this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'bg-end-game')
			.setScale(1);

		this.home = this.add
			.image(
				this.cameras.main.width / 2 + 150,
				this.cameras.main.height / 2 + 375,
				'home_btn' + language,
			)
			.setScale(1.2)
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				clickSound.play();
				this.chatChannel.postMessage(JSON.stringify({ action: 'home' }));
				this.scene.start(CST.SCENES.MENU, {
					scene: CST.SCENES.ENDSCREEN,
				});
			})
			.setScale(0.95);

		this.replay = this.add
			.image(
				this.cameras.main.width / 2 - 150,
				this.cameras.main.height / 2 + 375,
				'replay_btn' + language,
			)
			.setScale(1.2)
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				clickSound.play();
				this.chatChannel.postMessage(JSON.stringify({ action: 'replay' }));
				this.scene.start(CST.SCENES.BOARD, {
					scene: CST.SCENES.ENDSCREEN,
					data: data.data,
				});
			})
			.setScale(0.95);

		if (data.scene === CST.SCENES.BOARD) {
			this.scene.remove(CST.SCENES.BOARD);
			this.scene.add(CST.SCENES.BOARD, Board, false);
		}
	}
}
